module.exports = __webpack_public_path__ + "static/media/train-card12.3521c630.jpg";